import { isStaleChunkError as e } from "./isStaleChunkError.mjs";
import { isUpdatePending as t } from "@maat/store-error";
//#region src/staleChunk/shouldAttemptRecoveryReload.ts
function n(n) {
	return e(n) || t();
}
//#endregion
export { n as shouldAttemptRecoveryReload };
